import { render, staticRenderFns } from "./NotionResumeCard.vue?vue&type=template&id=2780e650&scoped=true&"
import script from "./NotionResumeCard.vue?vue&type=script&lang=js&"
export * from "./NotionResumeCard.vue?vue&type=script&lang=js&"
import style0 from "./NotionResumeCard.vue?vue&type=style&index=0&id=2780e650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2780e650",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
